export default{
    //更新前瞻
    Update:{
        updateoup:'更新前瞻',
        newNotice:'最新公告',
        xinxi1:'《塔防游戏》2025年全新版本“狂热之夜”即将上线，全新的地图、全新的英雄、全新的玩法，等你来战！',
        xinxi2:'《塔防游戏》2025年1月2日更新公告',
        xinxi3:'《塔防游戏》2024年12月18日更新公告',
        xinxi4:'《塔防游戏》异界出及——大宝剑',
        xinxi5:'《塔防游戏》2024年11月30日更新公告'
    },
    //特色
    feature:{
        tilteName:'游戏特色'
    },
    //底部
    foorter:{
        YHZX:'用户中心',
        KFZX:'客服中心',
        FWTK:'服务条款',
        YSZC:'隐私政策',
        GYWM:'关于我们',
        ZX:'账号注销',
        p1:'本网站上的图像版权归我们公司所有，未经许可不得复制',
        p2:'健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防上当受骗 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活',
        p3:'违法有害信息举报热线：4009936669',
        p4:'文化部网络游戏举报及联系邮箱：wlyxjb@gmail.com',
        gsmc:'公司名称：四川活力糖科技有限公司',
        gsdz:'地址：中国（四川）自由贸易试验区成都高新区府城大道西段399号天府新谷7号楼C座6楼7号',
    },
    //注销
    zhuxiao:{
        daTs:'账号注销须知',
        yedu:'请仔细阅读以下须知并完成身份验证',
        fxTs:'注销风险提示',
        title:'账号注销',
        ts1:'账号注销后，所有游戏数据（角色、道具、充值记录等）将被永久删除，无法恢复。',
        ts2:'注销后该账号将无法登录所有关联的游戏产品。',
        ts3:'若账号内有未消耗的虚拟货币、未到期的会员服务，注销后不予退还。',
        ts4:'注销操作提交后，系统将在24小时内完成处理，期间账号将被临时冻结。',
        chhu:'称呼',
        zhID:'编号',
        email:'邮箱',
        chhuTs:'请输入称呼',
        zhIDTs:'请输入编号',
        emailTs:'请输入邮箱（选填）',
        anNiu:'确认注销账号',
        fhTs:'返回重新操作',
        tjcg:'注销申请提交成功',

        quren:'最终确认',
        zxtsEr:'您确定要注销该游戏账号吗？',
        qurenTs:'注销后所有数据将永久删除，且无法恢复！',
        qrtx:'请输入 “确认注销” 以确认您的账号注销申请',
        tjAn:'提交注销',
        quxiao:'取消',

        // 注销提示
        ch_message:'请输入称呼',
        id_message:'请输入编号',
        email_message:'请输入正确的邮箱格式',
        confirm_message:'请输入正确的确认文本',

        Gui_ch:'称呼长度为3-30位',
        Gui_id:'ID长度为6-20位',

    }
    
}